import { RefreshIcon } from '@heroicons/react/outline';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/Button';

import V1Error from './V1Error';
import V2Error from './V2Error';

interface Props {
  error?: V1Error | V2Error;
  errorInfo?: React.ErrorInfo;
}

const AppErrorGlobalFallback: React.FC<Props> = ({ error, errorInfo }) => {
  const navigate = useNavigate();

  if (!error) {
    return (
      <main className="flex justify-center p-20 items-center w-screen h-screen bg-gray-100">
        <section className="max-w-96">
          <h1 className="text-xl font-semibold text-center">
            데이터를 불러오는 도중 문제가 발생했습니다.
          </h1>
        </section>
      </main>
    );
  }

  return (
    <main className="flex flex-col justify-center p-20 items-center w-screen h-screen bg-primary-50">
      <section className="w-2/3">
        <h1 className="text-xl font-semibold text-center">
          데이터를 불러오는 도중 문제가 발생했습니다.
        </h1>

        {isDev && (
          <div className="w-2/3 mx-auto mt-10">
            {/* API 에러 케이스 */}
            {error instanceof V1Error ? (
              error.error?.errors?.map((error, i) => (
                <code
                  key={i}
                  className="block p-6 bg-red-50 border-red-500 text-red-700 border font-medium text-xs whitespace-pre-line rounded overflow-auto mt-2 first-of-type:mt-0"
                >
                  {error.code
                    ? `[${error.code}] ${error.message}`
                    : error.message || ''}
                </code>
              ))
            ) : error instanceof V2Error ? (
              <code className="block p-6 bg-red-50 border-red-500 text-red-700 border font-medium text-xs whitespace-pre-line rounded overflow-auto mt-2 first-of-type:mt-0">
                [{error.error?.errorDomain?.toUpperCase() || 'ERROR'}]{' '}
                {error.error?.errorCode?.toUpperCase()}
              </code>
            ) : null}

            {/* 런타임 에러 케이스 */}
            {(!(error instanceof V1Error) || !(error instanceof V2Error)) &&
              errorInfo && (
                <code className="block p-6 bg-red-50 border-red-500 text-red-700 border font-medium text-xs whitespace-pre-line rounded overflow-auto">
                  {errorInfo.componentStack.trim()}
                </code>
              )}
          </div>
        )}
      </section>
      <section className="mt-10 flex justify-center items-center">
        <Button
          variant="solid"
          iconElement={[<RefreshIcon />]}
          onClick={() => {
            navigate('/');
            location.reload();
          }}
        >
          홈으로
        </Button>
      </section>
    </main>
  );
};

export default AppErrorGlobalFallback;
